//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { EventBus } from '../../EventBus/EventBus'
import { loadObjectActiveRequests } from './Request.js'
import { requestWorkTypes } from './RequestWorkTypes.js'
import BusinessProcessMessages from '../../components/BusinessProcess/BusinessProcessMessages.vue'
import ReportsHistory from '../Report/ReportsHistory.vue'
import RequestBpStateChanges from './RequestBpStateChanges.vue'
import RequestRoadsInfo from './RequestRoadsInfo.vue'
import RequestRejectReopen from './RequestRejectReopen.vue'
import RequestRoadsIntegration from './RequestRoadsIntegration.vue'
import RequestMgtIntegration from './RequestMgtIntegration.vue'
import Comments from '../../components/Comments/Comments.vue'
import RequestPriority from './RequestPriority.vue'
import RequestFiles from './RequestFiles.vue'
import RequestGeneralInfo from './RequestGeneralInfo.vue'
import RequestWorksSection from './RequestWorksSection.vue'
import RequestExecutor from './RequestExecutor.vue'
import RequestInitialization from './RequestInitialization.vue'
import RequestObjectActiveRequests from './RequestObjectActiveRequests.vue'
import RequestAuditServiceObjects from './RequestAuditServiceObjects.vue'
import RequestNoVISTypeBanner from './RequestNoVISTypeBanner.vue'
import DocumentAuditRemarks from './DocumentAuditRemarks.vue'
import RequestReinforcementExecutor from './RequestReinforcementExecutor.vue'
import ServiceObjectMaintenanceNotesTable from '../../forms/ServiceObjectMaintenanceNote/ServiceObjectMaintenanceNotesTable.vue'
import ServiceObjectZabbixMonitoringStatus from '../../forms/ServiceObject/ServiceObjectZabbixMonitoringStatus.vue'
import ReportContentSection from '../Report/ReportContent/ReportContentSection.vue'

export default {
  name: 'Request',
  components: {
    BusinessProcessMessages,
    RequestGeneralInfo,
    RequestFiles,
    RequestPriority,
    Comments,
    RequestRoadsInfo,
    RequestRejectReopen,
    RequestRoadsIntegration,
    RequestMgtIntegration,
    RequestBpStateChanges,
    ReportsHistory,
    RequestWorksSection,
    RequestExecutor,
    RequestInitialization,
    RequestAuditServiceObjects,
    DocumentAuditRemarks,
    RequestObjectActiveRequests,
    RequestReinforcementExecutor,
    RequestNoVISTypeBanner,
    ServiceObjectMaintenanceNotesTable,
    ServiceObjectZabbixMonitoringStatus,
    ReportContentSection
  },
  mixins: [requestWorkTypes],
  props: {
    request: {
      type: Object,
      required: true
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default: ''
    },
    isInitialize: {
      type: Boolean,
      default: false
    },
    isCreateAudit: {
      type: Boolean,
      default: false
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    hasFinishReportCreatedOrEditing: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    const user = this.$store.getters.getUser
    const notBrigadier = !user.hasRole('brigadier')
    const isRequestCreation = !!this.isInitialize || !!this.isCreateAudit

    return {
      requestImagesEditMode: false,
      requestDocFilesEditMode: false,
      isInitializeHistory: false,
      objectActiveRequests: [],

      expansionItem: {
        auditServiceObjects: notBrigadier,
        objectActiveRequests: false,
        images: isRequestCreation || !!this.request.filesGroupsMap.images.files.length,
        enclosure: isRequestCreation || !!this.request.filesGroupsMap.docFiles.files.length,
        techTask: isRequestCreation || !!this.request.filesGroupsMap.technicalTasks.files.length,
        auditRemarks: !!(this.request.auditRemarks || this.request.auditRemarksDocuments && this.request.auditRemarksDocuments.length > 0),
        comment: !!(notBrigadier && this.request.comments && this.request.comments.length),
        roadsMskInfo: false,
        roadsRejectReopen: false,
        roadsIntegration: false,
        mgtInfo: false,
        statusHistory: false,
        generalInfo: true,
        priority: notBrigadier,
        worksScope: true,
        contractorWorksScope: true,
        autoAssignWorksScope: true,
        maintenanceNotes: this.request.maintenanceNotes && this.request.maintenanceNotes.length !== 0,
        executor: notBrigadier,
        initiatorRequests: this.request.initiatorRequests && this.request.initiatorRequests.length !== 0,
        initiatedRequests: this.request.initiatedRequests && this.request.initiatedRequests.length !== 0,
        synchronizeSourceRequest: !!this.request.synchronizeSourceRequest,
        synchronizeTargetRequest: !!this.request.synchronizeTargetRequest,
        reportHistory: false
      },
      showAllActiveRequestsTypes: false
    }
  },
  computed: {
    objectActiveRequestsFiltered: function () {
      if (this.request.requestTypeObject && !this.showAllActiveRequestsTypes) {
        return this.objectActiveRequests.filter(request => request.typeId === this.request.requestTypeObject.id)
      } else {
        return this.objectActiveRequests
      }
    },
    isAudit: function () {
      return !!(this.request.audit || this.request.auditObject || this.isCreateAudit)
    },
    requestEditable: function () {
      if (!this.requestRoles.hasEditAccess) {
        return false
      }

      const user = this.$store.getters.getUser
      const supervisor = user.restrictedAccess && user.hasRole('externalDispatcher')
      if (this.requestRoles.roleExternalDispatcher || supervisor) {
        return (this.taskStatus === 'BS0' || this.taskStatus === 'BS1' || this.taskStatus == 'BS9' || this.taskStatus == 'BS21') || supervisor && this.taskStatus === 'BS2'
      }
      return (this.taskStatus === 'BS0' ||
      ((this.taskStatus == 'BS1' || this.taskStatus == 'BS2' || this.taskStatus == 'BS4' || this.taskStatus == 'BS5' || this.taskStatus == 'BS8' || this.taskStatus == 'BS10' || this.taskStatus == 'BS13') && this.requestRoles.roleDispatcherOrHigher) ||
      (this.taskStatus == 'BS3' && (this.requestRoles.roleDispatcherOrHigher || this.requestRoles.roleExecutor))) &&
      this.requestRoles.editAvailable // TODO
    },
    requestFilesReadonly: function () {
      const user = this.$store.getters.getUser
      const supervisor = user.restrictedAccess && user.hasRole('externalDispatcher')
      if (this.requestRoles.roleExternalDispatcher || supervisor) {
        return !this.requestEditable
      }
      return !(this.requestEditable && (this.taskStatus === 'BS0' || this.requestRoles.roleDispatcherOrHigher))
    },
    requestFilesEditable: function () {
      const user = this.$store.getters.getUser
      const supervisor = user.restrictedAccess && user.hasRole('externalDispatcher')
      if (this.requestRoles.roleExternalDispatcher || supervisor) {
        return !this.requestFilesReadonly
      }
      return !this.requestFilesReadonly &&
      ((this.taskStatus === 'BS0' || ((this.taskStatus === 'BS1' || this.taskStatus === 'BS2') && (this.request.requestSource && this.request.requestSource.key === 'deltaSDPEmployee') && this.requestRoles.roleDispatcherOrHigher)))
    },
    showReportsHistory: function () {
      return this.$d_hasOperation('serviceObjectReportsView') && !this.externalDispatcherBounded && // externalDispatcherBounded - отображать историию, но только по доступным отчётам
      !!this.request && !!this.request.serviceObject &&
      !this.isInitialize && !this.request.requestsToAudit
    },
    externalDispatcherBounded: function () {
      const user = this.$store.getters.getUser
      return user.hasRoleStrict('externalDispatcher') && !user.hasRole('dispatcher')
    },
    restrictedExternalUser: function () {
      const user = this.$store.getters.getUser
      return !!(user.restrictedAccess && user.employee && user.employee.external)
    },
    notExternalDispatcherCreation: function () {
      return !(this.taskStatus == 'BS0' && this.requestRoles.roleExternalDispatcher)
    },
    bpMessages: function () {
      return this.request && this.request.actionsProps && this.request.actionsProps.messages || []
    },
    showNotInVISBanner: function () {
      return this.request.requestTypeObject && !this.request.requestTypeObject.hasActualRequestInVis &&
      (
        this.taskStatus === 'BS0' ||
        this.requestInitial.requestTypeObject &&
        this.requestInitial.requestTypeObject.id !== this.request.requestTypeObject.id
      )
    },
    activeContentSectionId: function () {
      if (!this.$store.state.requestContent) {
        return null
      }
      return this.$store.getters['requestContent/getActiveSectionId']
    }
  },
  watch: {
    activeContentSectionId: function (id) {
      if (!id) {
        return
      }
      const generalInfoIds = [
        'section-request-info',
        'section-request-source',
        'section-request-data-source',
        'section-delivery-vis',
        'section-vis-id',
        'section-request-type',
        'section-create-time',
        'section-deadline',
        'section-initiator',
        'section-applicant-description',
        'section-service-object-info',
        'section-service-object',
        'section-contract',
        'section-object-address',
        'section-address',
        'section-coordinates',
        'section-roads-labels'
      ]
      if (generalInfoIds.indexOf(id) !== -1) {
        this.expansionItem.generalInfo = true
      }
    }
  },
  beforeDestroy: function () {
    EventBus.$off('show-reinforcements', this.onShowReinforcements)
  },
  created: function () {
    EventBus.$on('show-reinforcements', this.onShowReinforcements)

    if (this.requestFilesReadonly) {
      this.request.filesGroupsMap.images.readonly = true
      this.request.filesGroupsMap.docFiles.readonly = true
      this.request.filesGroupsMap.technicalTasks.readonly = true
    }

    if (this.request.serviceObject && this.request.serviceObject.id) {
      loadObjectActiveRequests(this.request.serviceObject.id, this)
        .then(requests => {
          this.objectActiveRequests = requests
        })
    }
  },
  methods: {
    onShowReinforcements: function (brigades) {
      this.$refs.reinforcementExecutorsSection.show()
      this.$refs.reinforcementExecutorsSection.$el.scrollIntoView({ behavior: 'smooth' })
    },
    onChangeServiceObject: function (serviceObject) {
      if (serviceObject) {
        return loadObjectActiveRequests(serviceObject.id, this)
          .then(requests => {
            this.objectActiveRequests = requests
          })
      } else {
        this.objectActiveRequests = []
      }
    }
  }
}

